import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { BridgeSiteSettingsProps } from '~src/settings/bridge-settings/BridgeSiteSettings';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { multiPoolTableStyle, sectionExtraPaddingBottom } from './bridgeMultiPool/BridgeMultiPoolSection';
import { BridgeRemoteAgentsSectionBody } from './bridgeRemoteAgents/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from './bridgeRemoteAgents/BridgeRemoteAgentsSectionHeaders';

export function BridgeUnassignedRemoteAgentsSection(props: BridgeSiteSettingsProps) {
  return <>
    {FeatureFlags.edgeMultiPoolEnabled ?
      <SettingsSection title={''} testId={'bridge-unassigned-remote-agents-section'}>
        <div className={sectionExtraPaddingBottom}>
          <div className={'tb-data-grid-title-text'}>{Messages.siteRemoteAgentSettingsUnassignedClients()}</div>
          <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
            <BridgeRemoteAgentsSectionHeaders isDefaultPool={false} />
            <BridgeRemoteAgentsSectionBody
              isDefaultPool={false}
              pools={props.edgePools.userDefinedPools}
              connectionStatuses={props.connectionStatuses}
              siteId={props.settings.id}
              refreshEdgePools={props.refreshEdgePools}
              agents={Object.values(props.edgePools.unassignedAgents)}
              hasLoadedEdgePools={props.hasLoadedEdgePools}
            />
          </table>
        </div>
      </SettingsSection>
      : null}
  </>;
}

/* for registering the component in settings registry */
export const BridgeUnassignedRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeUnassignedRemoteAgentsSection',
  component: BridgeUnassignedRemoteAgentsSection
});
